function trimTrailingSlash (value) {
  return value ? value.replace(/\/+$/, '') : ''
}

function resolveBackendBaseUrl () {
  const configuredBaseUrl = trimTrailingSlash(process.env.VUE_APP_FILE_BASE_URL || process.env.VUE_APP_API_BASE_URL)
  if (configuredBaseUrl) {
    return configuredBaseUrl
  }

  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === 'development' ? 'http://localhost:8082' : ''
  }

  const { protocol, hostname, port } = window.location
  if (process.env.NODE_ENV === 'development') {
    return `${protocol}//${hostname}:8082`
  }

  // Frontend and backend are often split locally; if the page isn't already on 8082, point uploads to backend.
  if ((hostname === 'localhost' || hostname === '127.0.0.1') && port && port !== '8082') {
    return `${protocol}//${hostname}:8082`
  }

  return ''
}

export function resolveFileUrl (url) {
  if (!url) {
    return ''
  }
  if (/^https?:\/\//i.test(url)) {
    return url
  }
  const normalized = url.startsWith('/') ? url : `/${url}`
  const backendBaseUrl = resolveBackendBaseUrl()
  return backendBaseUrl ? `${backendBaseUrl}${normalized}` : normalized
}
